import posthog from "posthog-js";
import { POSTHOG_EVENTS } from "../constants/PostHogEvents";
interface CaptureOptions {
	send_instantly?: boolean;
	timestamp?: Date | string | number;
}

class PostHogService {
	private buildCaptureOptions(options?: CaptureOptions): any {
		const captureOptions: any = { send_instantly: options?.send_instantly };
		if (options?.timestamp) {
			captureOptions.timestamp =
				options.timestamp instanceof Date ? options.timestamp : new Date(options.timestamp);
		}
		return captureOptions;
	}

	trackEvent(eventName: POSTHOG_EVENTS | string, properties?: Record<string, any>, options?: CaptureOptions) {
		const enrichedProperties = { ...properties };

		posthog.capture(eventName, enrichedProperties, this.buildCaptureOptions(options));
	}
}

export const postHogService = new PostHogService();
export default postHogService;
